/* eslint-disable sonarjs/cognitive-complexity */
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'
import {
  setForm,
  fetchGetPurchaseOrderReferences,
  fetchPutSupplyOrderDetail,
  fetchGetSupplyOrderDetail,
  fetchGetSupplyOrderDetailItem,
} from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { usePopupConfirmation } from 'components/PopupConfirmation'
import { useParams } from 'react-router-dom'
import { toastSuccess } from 'utils/toast'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'

const useBasicDetail = () => {
  const { id } = useParams<{ id: string }>()
  const isEdit = Boolean(id)

  const dispatch = useAppDispatch()

  const userData = useAppSelector((state) => state.auth.userData, shallowEqual)
  const {
    data,
    form,
    errorField,
    constants: { locations, poRefferences, remarks, type },
  } = useAppSelector((state) => state.outboundSOAddEdit, shallowEqual)

  const { handleOpenConfirmation } = usePopupConfirmation()

  const constants = {
    poRefferences: userData?.isSuperAdmin
      ? poRefferences
      : poRefferences.filter((po) =>
          userData?.user_locations?.some((loc) => loc.location_id === po.destinationId),
        ),
    origins: userData?.isSuperAdmin ? locations : userData?.user_locations,
    destinations: locations,
    locations,
    remarks,
    type,
  }

  const handleChangeOrigin = (value: typeof form.origin) => {
    const supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest'] = {
      createdBy: data?.supplyOrderCreatedBy || '',
      locationDestinationId:
        form.soType.toLowerCase() === 'return'
          ? form.poReff?.vendorId || 0
          : form.destination?.location_id || 0,
      locationOriginId: value?.location_id || 0,
      remarks: form?.remarks?.code || '',
      poRef: form?.poReff || {},
      requestBy: form?.email || '',
      shippingInstructions: form?.shippingInstructions || '',
      soDate: form.soDate ? form.soDate.getTime() : 0,
      soReff: form.soReff || '',
      soType: form.soType || '',
      status: data?.supplyOrderStatus || '',
    }

    dispatch(
      fetchPutSupplyOrderDetail({
        supplyOrderId: Number(id),
        payload: {
          supplyOrderRequest,
        },
        onSuccess: async () => {
          dispatch(setForm({ key: 'origin', value }))
          toastSuccess('Data asal pengiriman berhasil diubah')
          fetchGetSupplyOrderDetail(Number(id))
          dispatch(
            fetchGetSupplyOrderDetailItem({
              supplyOrderId: Number(id),
              params: {
                pageIndex: 0,
              },
            }),
          )
        },
      }),
    )
  }

  const handleChangeForm = (key: keyof typeof form, value: (typeof form)[typeof key]) => {
    if (key === 'origin' && isEdit) {
      handleOpenConfirmation({
        type: 'danger',
        title: 'Ubah Asal Pengiriman?',
        message: 'Barang akan hilang jika anda mengubah lokasi asal',
        submitText: 'Ya, Ubah Lokasi Asal',
        onSubmit: () => {
          handleChangeOrigin(value as typeof form.origin)
        },
      })

      return
    }

    if (key === 'soType' && typeof value === 'string' && value.toLowerCase() === 'return') {
      dispatch(
        fetchGetPurchaseOrderReferences({
          poNumber: '',
        }),
      )
    }

    dispatch(setForm({ key, value }))
  }

  const handleSearchPOReff = (search: string) => {
    dispatch(
      fetchGetPurchaseOrderReferences({
        poNumber: search,
      }),
    )
  }

  return {
    constants,
    data,
    form,
    errorField,
    handleChangeForm,
    handleSearchPOReff,
  }
}

export default useBasicDetail
